export const version = 'berater-v1.18.0';